export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Показано:"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["всього"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["На сторінці"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Показати"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Результати"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["з"])},
  "22": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Угода"])},
  "23": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Угод"])}
}